import React from "react";
import { Card } from "../../pages/Theme";

const EditCardPost = () => {
    return(
        <Card className="flex flex-row md:pr-5 lg:pr-10 mt-5 mb-5 rounded-xl">
            
            <div className="lg:mr-5 w-80 bg-gray-200 h-80 rounded-md"></div>               
            <div className="flex flex-col pt-1 lg:pt-0 pb-7 lg:pb-7 pl-4 pr-4 md:pr-0">
                
                <div className="flex flex-row lg:flex-row pt-3 mb-5 items-center">
                    <div className="mt-2 w-10 bg-gray-200 h-10 rounded-full"></div>
                    <div className="flex flex-col ml-5 ">
                        <div className="mt-2 w-32 bg-gray-200 h-3.5 rounded-md"></div>  
                        <div className="mt-2 w-32 bg-gray-200 h-3.5 rounded-md"></div>
                    </div>                    
                </div>
                <div className="">
                    <div className="mt-2 lg:w-96 bg-gray-200 h-4 rounded-md"></div>
                    <div className="mt-2 lg:w-96 bg-gray-200 h-4 rounded-md"></div>
                    <div className="mt-2 lg:w-9/12 bg-gray-200 h-4 rounded-md"></div>
                </div>                
                <div className="flex flex-col mt-10">
                    <div className="mt-2 w-6/12 bg-gray-200 h-4 rounded-md"></div>
                    <div className="mt-2 w-10/12 bg-gray-200 h-4 rounded-md"></div>            
                    
                </div>
                
            </div>              

            
        </Card>
    )
}


export default EditCardPost